import React, { useCallback } from 'react'
import { getPosPriceByIndex } from '../../../../../helper'
import PlusMinus from '../../CartItem/PlusMinus'
import CustomModal from '../../../modal/CustomModal'
import { getConvertedProduct2Item } from '../../../../../helper/convertor'

const ModalToppingGrid = React.memo(({ isOpen, item, focusedItem, orderType, addTopping, close, module }) => {
	const addToppingItem = useCallback((quantity) => {
		const priceIndex = focusedItem.priceIndex
		const price = getPosPriceByIndex(item, orderType, priceIndex)
		const priceTitleId = price.priceTitle.id
		let toppingItem = getConvertedProduct2Item({ product: item, quantity, price: price.value, priceIndex: priceIndex, items: null, priceTitleId, module })
		addTopping(toppingItem)
		close()
	}, [focusedItem, item, orderType, addTopping, close, module])

	const handlePlus = useCallback(() => {
		addToppingItem(1)
	}, [addToppingItem])

	const handleMinus = useCallback(() => {
		addToppingItem(-1)
	}, [addToppingItem])

	return (
		<CustomModal isOpen={isOpen}
								 size="auto"
								 id="topping-lf-grid-modal"
								 title={item.title}
								 close={close}
								 autoFocus={false}>
			<PlusMinus {...{ onClickPlus: handlePlus, onClickMinus: handleMinus, incrementAbility: true, removeAbility: true, size: 'large' }} />
		</CustomModal>
	)
})

ModalToppingGrid.displayName = 'ModalToppingGrid'
export default ModalToppingGrid
